'use client';
import { Portal } from '@ark-ui/react';
import Script from 'next/script';
import { useMedia } from 'react-use';
import { useVipStateWithCache } from '~/common/hooks/use-vip-state-with-cache';
import { Breakpoints } from '~/utils/styles/enums';
import { Box, Center } from '@styled-system/jsx';
import { useInitAd } from './use-init-ad';

type Props = {
  canShowGoogleAd: boolean;
};

const _MicroAdOverlayContainer = ({ adId }: { adId: string }) => {
  useInitAd(adId);

  return (
    <Portal>
      <Script id="microad">
        {`var microadCompass = microadCompass || {}; microadCompass.queue = microadCompass.queue || [];`}
      </Script>
      <Box
        position="fixed"
        bottom={{
          base: 'calc(env(safe-area-inset-bottom) + 54px)',
          lg: '0',
        }}
        left={0}
        right={0}
        width="100%"
        background="rgba(0, 0, 0, 0)"
        zIndex="overlayAdsContainer"
        textAlign="center"
        transform="translate3d(0, 0, 0)"
        hideFrom="lg"
      >
        <Center width="100%" id={adId}></Center>
      </Box>
    </Portal>
  );
};

export const MicroAdOverlayContainer = ({ canShowGoogleAd }: Props) => {
  const adId = canShowGoogleAd
    ? 'fd905be452c60ce2c2f2f2b03b867cc9'
    : 'ea89c9c791c673151c702442c2e4a1df';
  const { storedVipState } = useVipStateWithCache();
  const screenLarge = useMedia(`(min-width: ${Breakpoints.md})`, undefined);
  const isMobile =
    typeof screenLarge === 'undefined' ? undefined : !screenLarge;

  const enableMicroad = isMobile === true && !storedVipState;

  if (!enableMicroad) return null;

  return <_MicroAdOverlayContainer adId={adId} />;
};
